/**
 * 606 Meta5 AI Trading - P&L Display Component
 */
import React from 'react';

const PnL = ({ value, size = 'md', showSign = true, currency = '$' }) => {
  const isPositive = value > 0;
  const isNegative = value < 0;
  
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  };
  
  return (
    <span className={`font-semibold ${sizeClasses[size]} ${
      isPositive ? 'text-emerald-400' : isNegative ? 'text-red-400' : 'text-[#71717A]'
    }`}>
      {showSign && isPositive && '+'}
      {currency}{Math.abs(value).toFixed(2)}
    </span>
  );
};

export default PnL;
